/** @format */
import React, { useEffect } from 'react';
import { Grid, CircularProgress, Button } from '@mui/material';
import { useForm } from 'react-hook-form';
import { InputV, ComparativeAccount } from 'components';
import comparativeAccountServices from 'components/ComparativeAccount/services/ComparativeAccountServices';
import { useStyles } from './style';
import { useNavigate } from 'react-router-dom';
import { createAccount } from '../../services/DetailAccountsServices';
import createToast from 'components/Toast/Toast';
import useCustomHook from '../hooks';

export function CreateDetailAccounts(props) {
    const classes = useStyles();
    const { control, handleSubmit, formState: { errors }, watch, setValue, register } = useForm();
    const {
        comparativeAccountList,
        setComparativeAccountList,
        loadBtn,
        setLoadBtn,
    } = useCustomHook();

    const navigate = useNavigate();

    useEffect(() => {
        (async () => {
            try {
                const result = await comparativeAccountServices.getList();
                const { data } = result;
                setComparativeAccountList({
                    list: data.result.guilds,
                    selectedList: data.result.businessGuilds,
                });
            } catch (error) { }
        })();
    }, []);

    const onSubmit = (data) => {
        setLoadBtn(true);

        let dataApi = {
            guildCode: data.comparativeAccount.code,
        };

        if (data?.aliasName) {
            dataApi = { ...dataApi, aliasName: data.aliasName };
        }

        async function creatAccount(params) {
            try {
                await createAccount(params);
                createToast('موفق', 'ایجاد حساب با موفقیت انجام شد.', 'success');
                navigate('/Guilds');
            } catch (error) {
                return;
            }
            setLoadBtn(false);
        }
        creatAccount(dataApi);
    };

    const watchList = watch('comparativeAccount');

    const hint = 'در این صفحه می‌توانید حساب کسب‌و‌کاری جدید تعریف کنید.';
    return (
        <>
            <form onSubmit={handleSubmit(onSubmit)} noValidate autoComplete="off">
                <Grid container spacing={4}>
                    <Grid item xs={12}>
                        <ComparativeAccount
                            errors={errors}
                            control={control}
                            name="comparativeAccount"
                            register={register}
                            selectedList={comparativeAccountList.selectedList}
                            list={comparativeAccountList.list}
                        />
                        <Grid item xs={12}>
                            {watchList?.code.substring(0, 9) == 'DIMENSION' ? (
                                <InputV
                                    fullWidth
                                    className={classes.alias}
                                    errors={errors}
                                    label="نام مستعار"
                                    name="aliasName"
                                    register={register}
                                    control={control}
                                />
                            ) : (
                                ''
                            )}
                        </Grid>
                    </Grid>
                    <Grid item xs={12} className={classes.cardActions}>
                        <Button type="submit" color="primary" variant="contained" className={classes.button}>
                            ثبت
                            {loadBtn && <CircularProgress size={24} className={classes.backdrop} />}
                        </Button>
                        <Button variant="contained" onClick={() => navigate('/Guilds')}>
                            انصراف
                        </Button>
                    </Grid>
                </Grid>
            </form>
        </>
    );
};

